import dynamic from 'next/dynamic'
import styled from 'styled-components'

const DMPrimaryButton = dynamic(
  () =>
    import('@decormatters/dm-theme').then(
      component => component.DMPrimaryButton
    ),
  { ssr: false }
)

const DMPrimaryAltButton = dynamic(
  () =>
    import('@decormatters/dm-theme').then(
      component => component.DMPrimaryAltButton
    ),
  { ssr: false }
)

export const Container = styled.div`
  flex: 0 0 410px;
  background-color: white;
  overflow-x: hidden;
  overflow-y: auto;
`

export const Content = styled.div`
  padding: 27px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 820px) and (min-width: 600px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const LeftProfileInfoPart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 820px) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    gap: 27px;
  }
`

export const AvatarAccessory = styled.img`
  position: absolute;
  left: 51%;
  top: 45%;
  width: 200px;
  height: 200px;
  transform: translate(-50%, -50%);
  z-index: 999;

  @media screen and (max-width: 820px) {
    top: -20px;
    left: -20px;
    left: 50%;
    top: 50%;
    width: 100px;
    height: 100px;
  }
`

export const AvatarContainer = styled.button`
  border: 0;
  background: none;
  position: relative;
  width: 180px;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  @media (min-width: 1000px) {
    transform: scale(0.8);
    transform-origin: top;
    margin-bottom: -40px;
  }

  @media screen and (max-width: 820px) and (min-width: 600px) {
    transform-origin: top;
    transform: scale(0.6);
    width: 180px;
    height: 100px;
  }

  @media screen and (max-width: 600px) {
    transform: scale(0.6);
    margin-right: 10px;
    width: 170px;
    height: 100px;
  }
`

export const Username = styled.div`
  width: 100%;
  margin-top: 28px;
  margin-bottom: 22px;
  white-space: nowrap;
  font-weight: 500;
  font-size: 24px;
  text-align: center;

  @media screen and (max-width: 820px) {
    margin-top: 0;
    margin-bottom: 0;
    color: #000;
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }
`

export const Description = styled.div`
  width: 100%;
  font-size: 18px;
  white-space: wrap;
  margin-bottom: 22px;
  overflow: hidden;
  text-align: center;

  @media screen and (max-width: 820px) {
    margin-bottom: 0;
    color: #8b8b8b;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.14px;
    text-align: left;
  }
`

export const BasicUserInfoContainer = styled.div`
  @media screen and (max-width: 820px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
  }
`

export const EditProfileButton = styled(DMPrimaryAltButton)`
  margin: 15px 0 0;

  @media screen and (max-width: 820px) {
    height: 32px;
    color: #ff5e6d;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.12px;
    margin: 0;
  }
`

export const FollowButton = styled(DMPrimaryAltButton)`
  margin: 25px 0;
  font-size: 16px;
  width: 135px;
  height: 42px;

  @media screen and (max-width: 820px) {
    width: 90px;
    height: 32px;
    color: #ff5e6d;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.12px;
    margin: 0;
  }
`

export const EditAvatarButton = styled.button`
  position: absolute;
  right: -15px;
  bottom: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff5e6d;
  border: 0;
  padding: 0 0 0 2px;
  cursor: pointer;
  z-index: 999;

  @media screen and (max-width: 820px) {
    right: -30px;
    bottom: -65px;
    width: 30px;
    height: 30px;
  }
  @media screen and (max-width: 600px) {
    display: none;
  }
`

export const MobileAvatarWrapper = styled.div`
  border: 3px solid #ededed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const MobileAvatar = styled.img`
  width: 79px;
  height: 79px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid white;
`

export const LevelPlank = styled.div`
  border-radius: 52px;
  background: #ff5e6d;
  box-shadow: 0px 2px 4px 0px rgba(255, 94, 109, 0.53);
  width: 34px;
  height: 14px;
  color: #fff;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  position: absolute;
  bottom: 0px;
  right: 0px;
`
